module.exports = __webpack_public_path__ + "static/media/features-hide-show.1bfa0893.svg";